/**
 * Shared Explorer page bootstrap.
 * Templates should provide window.EXPLORER_BOOTSTRAP; legacy globals are kept
 * as fallbacks so older entry points fail softly during deploys.
 */

const bootstrap = window.EXPLORER_BOOTSTRAP || {};

const coerceExplorerBoolean = (value) => value === true || value === 'true';

const defaultPricingDescriptions = {
  customers: { full: '1 base credit + 2 credits per customer returned', short: '1 base + 2/customer' },
  competitors: { full: '2 credits per competitor returned (min 5 credits)', short: '2/competitor (min 5)' },
  funding: { full: '2 base credits + 1 credit per investor returned', short: '2 base + 1/investor' },
  updates: { full: '2 credits per company', short: '2/company' },
  personProfile: { full: '3 credits per person profile', short: '3/profile' },
};

const explorerConfig = {
  MODE: bootstrap.mode || window.EXPLORER_MODE || 'public',
  INITIAL_DOMAIN: bootstrap.domain || window.EXPLORER_DOMAIN || '',
  INITIAL_SLUG: bootstrap.slug || window.EXPLORER_SLUG || bootstrap.domain || window.EXPLORER_DOMAIN || '',
  IS_GOOGLEBOT: coerceExplorerBoolean(bootstrap.is_googlebot ?? window.EXPLORER_IS_GOOGLEBOT),
  PRODUCT_ID: bootstrap.product_id || window.EXPLORER_PRODUCT_ID || '',
  PRODUCT_HOSTNAME: bootstrap.product_hostname || window.PRODUCT_HOSTNAME || '',
  PRODUCT_CREATED_AT: bootstrap.product_created_at || window.PRODUCT_CREATED_AT || '',
  API_KEY: bootstrap.api_key || window.MONITOR_API_KEY || '',
  PERSON_SLUG: bootstrap.person_slug || window.EXPLORER_PERSON_SLUG || '',
  PERSON_LOOKUP: bootstrap.person_lookup || window.EXPLORER_PERSON_LOOKUP || {},
  SHORTCUT_CARDS: bootstrap.shortcut_cards || window.EXPLORER_SHORTCUT_CARDS || {},
  FREE_DOMAINS: bootstrap.free_demo_domains || ['proxycurl.com', 'stripe.com', 'apollo.io'],
  PRICING_DESCRIPTIONS: bootstrap.pricing_descriptions || defaultPricingDescriptions,
};

explorerConfig.IS_DASHBOARD = explorerConfig.MODE === 'dashboard';

window.ExplorerConfig = explorerConfig;

// Compatibility for shared dashboard widgets loaded on Explorer pages.
window.MONITOR_API_KEY = explorerConfig.API_KEY;
window.PRODUCT_HOSTNAME = explorerConfig.PRODUCT_HOSTNAME;
window.PRODUCT_CREATED_AT = explorerConfig.PRODUCT_CREATED_AT;
